import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../PricingHub/SearchComponent';

class VoicePlansSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.planType',
      name: 'planType',
      tOptions: 'selections:planType',
      type: 'select',
      isClearable: true,
    },
    {
      label: 'label.planStatus',
      name: 'planStatus',
      tOptions: 'selections:planStatus',
      type: 'select',
      isClearable: true,
    },
  ];

  btnSpan = 'col-md-6';
}

VoicePlansSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

VoicePlansSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(VoicePlansSearchForm);
